import ListingForm from 'features/app/components/listings/ListingForm';
import ImageGallery from 'shared/ui/ImageGallery';
import { useStateContext } from 'shared/contexts/ContextProvider';
import { useLayout } from 'shared/contexts/LayoutContext';
import { SquarePen, TrashIcon } from 'lucide-react';
import { formatDate, formatNumber } from 'shared/utils/format';



function ListingItem({ item, onEdit}) {
  const { openModal, closeModal } = useLayout();
  const { currentColor, showToast, token } = useStateContext();

  const handleEditListing = () => {
    openModal({
      component: <ListingForm item={item}/>,
      title: 'Изменить листинг',
    });
  };

  
  const handleDeleteListing = async () => {
    const confirmDelete = window.confirm(`Вы уверены, что хотите удалить листинга ${item.name}?`);
    if (confirmDelete) {
      const response = await employeeService.delete(item.id);
      if(response.status === 0) {
        showToast({
          title: 'Успешно!',
          content: `Листинг ${item.name} удален`,
          type: 'success',
        });
        closeModal();
        refreshList ? refreshList() : null;
      }
      else{
        showToast({
          title: 'Ошибка!',
          content: response.message || 'Что-то пошло не так!',
          type: 'error',
        });
      }

    }
  }

  return (
    <div className='max-w-3xl mx-auto bg-white p-6'>
      <div className='mb-6'>
        <div className='flex justify-between items-start'>
          <h1 className='text-2xl font-normal mb-1'>{`${item.title}`}</h1>
          <div className='text-right space-x-2'>
          <button className=' text-white px-4 py-2 rounded-md hover:' style={{ backgroundColor: currentColor }} onClick={() => handleEditListing()}>
            <SquarePen size={16} className='mr-1' /> 
          </button>
          <button className=' text-white px-4 py-2 rounded-md hover: bg-red-500' onClick={() => handleDeleteListing()}>
            <TrashIcon size={16} className='mr-1' />
          </button>
        </div>
        </div>
        <div className='text-sm mb-2'>
          Создан {formatDate(item.created)}
        </div>
      </div>
      <ImageGallery urls={item.pictures} height='h-96' width='w-96' />


      <div className='mb-6'>
        <h2 className='text-lg font-medium mb-4'>Детали</h2>
        <div className='grid gap-4 '>
          <div className='space-y-2'>
            <div className='flex justify-between border-b border-dotted pb-1'>
              <span>Название</span>
              <span className='text-blue-600'>{item.title}</span>
            </div>
            <div className='flex justify-between border-b border-dotted pb-1'>
              <span>Путь</span>
              <span className='text-blue-600'>{item.path}</span>
            </div>
            <div className='flex justify-between border-b border-dotted pb-1'>
              <span>Описание</span>
              <span>{formatNumber(item.description)}</span>
            </div>
            <div className='flex justify-between border-b border-dotted pb-1'>
              <span>Цена</span>
              <span>{formatNumber(item.sale_price)}</span>
            </div>
            <div className='flex justify-between border-b border-dotted pb-1'>
              <span>Bonus</span>
              <span>{formatNumber(item.bonus)}</span>
            </div>
            <div className='flex justify-between border-b border-dotted pb-1'>
              <span>Скидка</span>
              <span>{formatNumber(item.discount_percent)}</span>
            </div>
          </div>
        </div>
      </div>





    </div>
  );
}

export default ListingItem;
